export default __webpack_public_path__ + "static/media/logo-with-bg-christmas.614a9f6b.jpg";